import { Controller } from '@hotwired/stimulus'

// Filters the sites of the company site switcher dropdown (Ui::Company::SiteSwitcherComponent).
export default class extends Controller {
  static targets = ['query', 'item', 'empty']

  focusQuery () {
    if (this.hasQueryTarget) this.queryTarget.focus()
  }

  filter () {
    const query = this.#normalize(this.queryTarget.value)
    let visibleCount = 0

    this.itemTargets.forEach((item) => {
      const visible = this.#normalize(item.dataset.search).includes(query)
      item.hidden = !visible
      if (visible) visibleCount += 1
    })

    this.emptyTarget.hidden = visibleCount > 0
  }

  reset () {
    if (!this.hasQueryTarget || this.queryTarget.value === '') return

    this.queryTarget.value = ''
    this.filter()
  }

  #normalize (text) {
    return (text || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()
  }
}
